const state = {
    clickedMapList: [],
    voteJson15982: null
}

const mutations = {
    SET_CLICKED_MAPLIST: (state, params)  => {
        const res = state.clickedMapList.filter(item => item === params);
        if(!res || res.length === 0) {
            state.clickedMapList.push(params)
        }
    },
    SET_VOTE_JSON: (state, params) => {
        state.voteJson15982 = params;
    }
}

const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}